<template>
  <el-descriptions
    title=""
    direction="vertical"
    :column="docId <= 3 ? 4 : 3"
    border
  >
    <el-descriptions-item label="抽奖费配置">
      <Form :model="formData" :label-width="80">
        <FormItem label="抽奖券id:" v-if="+docId <= 3">
          <Select v-model="formData.ticketType" style="width: 200px" :disabled="!isEditing">
            <template v-if="+docId <= 3">
              <Option
                :key="item.resourceId"
                v-for="item in ticketList"
                :value="item.resourceId"
                >{{ item.name }}</Option
              >
            </template>
          </Select>
        </FormItem>
        <FormItem
          :label="docId <= 3 ? `抽奖费` + (ind + 1) + ':' : getLotteryFeeLabel(ind)"
          v-for="(item, ind) in formData.lotteryFeesConfigList"
          :key="ind"
        >
          <Row>
            <Col span="8">
              <Input v-model="item.lotteryPrice" placeholder="" :disabled="!isEditing"></Input>
            </Col>
            <Col span="3" style="text-align: center">/</Col>
            <Col span="8">
              <Input v-model="item.lotteryCount" placeholder="" :disabled="!isEditing"></Input>
            </Col>
            <Col span="5" style="text-align: center">次数</Col>
          </Row>
        </FormItem>
      </Form>
    </el-descriptions-item>
    <el-descriptions-item label="概率配置">
      <Form :model="formData" :label-width="100">
        <FormItem :label="docId > 3 ? '普通用户奖池上限' : '游戏奖池上限'">
          <Row>
            <Col span="10">
              <Input v-model="formData.upperLimit" placeholder="" :disabled="!isEditing"></Input>
            </Col>
            <Col span="5" style="text-align: center">上限概率</Col>
            <Col span="9">
              <Input v-model="formData.upperLimitRate" placeholder="" :disabled="!isEditing"></Input>
            </Col>
          </Row>
        </FormItem>
        <FormItem :label="docId > 3 ? '普通用户奖池下限' : '游戏奖池下限'">
          <Row>
            <Col span="10">
              <Input v-model="formData.lowLimit" placeholder="" :disabled="!isEditing"></Input>
            </Col>
            <Col span="5" style="text-align: center">下限概率</Col>
            <Col span="9">
              <Input v-model="formData.lowLimitRate" placeholder="" :disabled="!isEditing"></Input>
            </Col>
          </Row>
        </FormItem>
        <FormItem :label="+docId <= 3 ? '奖池幸运值' : ''">
          <Row>
            <Col span="10" v-if="+docId <= 3">
              <Input v-model="formData.luckyValue" placeholder="" :disabled="!isEditing"></Input>
            </Col>
            <Col span="5" style="text-align: center">膨胀值</Col>
            <Col span="9">
              <Input v-model="formData.expandValue" placeholder="" :disabled="!isEditing"></Input>
            </Col>
          </Row>
        </FormItem>
      </Form>
    </el-descriptions-item>
    <el-descriptions-item label="概率配置2" v-if="docId > 3">
      <Form :model="formData" :label-width="100">
        <FormItem label="高净值用户奖池上限">
          <Row>
            <Col span="10">
              <Input v-model="formData.secUpperLimit" placeholder="" :disabled="!isEditing"></Input>
            </Col>
            <Col span="5" style="text-align: center">上限概率</Col>
            <Col span="9">
              <Input
                v-model="formData.secUpperLimitRate"
                placeholder=""
                :disabled="!isEditing"
              ></Input>
            </Col>
          </Row>
        </FormItem>
        <FormItem label="高净值用户奖池下限">
          <Row>
            <Col span="10">
              <Input v-model="formData.secLowLimit" placeholder="" :disabled="!isEditing"></Input>
            </Col>
            <Col span="5" style="text-align: center">下限概率</Col>
            <Col span="9">
              <Input v-model="formData.secLowLimitRate" placeholder="" :disabled="!isEditing"></Input>
            </Col>
          </Row>
        </FormItem>
      </Form>
    </el-descriptions-item>
    <el-descriptions-item label="概率配置3" v-if="docId === 901">
      <Form :model="formData" :label-width="100">
        <FormItem label="低价值用户奖池上限">
          <Row>
            <Col span="10">
              <Input v-model="formData.trdUpperLimit" placeholder="" :disabled="!isEditing"></Input>
            </Col>
            <Col span="5" style="text-align: center">上限概率</Col>
            <Col span="9">
              <Input
                v-model="formData.trdUpperLimitRate"
                placeholder=""
                :disabled="!isEditing"
              ></Input>
            </Col>
          </Row>
        </FormItem>
        <FormItem label="低价值用户奖池下限">
          <Row>
            <Col span="10">
              <Input v-model="formData.trdLowLimit" placeholder="" :disabled="!isEditing"></Input>
            </Col>
            <Col span="5" style="text-align: center">下限概率</Col>
            <Col span="9">
              <Input v-model="formData.trdLowLimitRate" placeholder="" :disabled="!isEditing"></Input>
            </Col>
          </Row>
        </FormItem>
      </Form>
    </el-descriptions-item>
    <el-descriptions-item label="分配比例">
      <Form :model="formData" :label-width="80">
        <FormItem :label="docId > 3 ? '普通用户奖池' : '游戏奖池'">
          <Input
            v-model="formData.gameRate"
            placeholder=""
            style="width: 200px"
            :disabled="!isEditing"
          ></Input>
        </FormItem>
        <FormItem v-if="docId === 901" label="低价值田户奖池 ">
          <Input
            v-model="formData.trdRate"
            placeholder=""
            style="width: 200px"
            :disabled="!isEditing"
          ></Input>
        </FormItem>
        <FormItem :label="docId > 3 ? '高净值用户奖池' : '幸运奖池'">
          <Input
            v-model="formData.luckyRate"
            placeholder=""
            style="width: 200px"
            :disabled="!isEditing"
          ></Input>
        </FormItem>
        <FormItem label="系统回收">
          <Input
            v-model="formData.systemRate"
            placeholder=""
            style="width: 200px"
            :disabled="!isEditing"
          ></Input>
        </FormItem>
      </Form>
    </el-descriptions-item>
    <el-descriptions-item label="操作">
      <div class="btn-group-outer">
        <div class="btn-group">
          <Button
            style="width: 100px"
            type="success"
            @click="$emit('open', true)"
            :disabled="!isEditing"
            >奖品配置</Button
          >
          <!-- <Button type="info">重置</Button> -->
          <Button
            v-if="isEditing"
            type="primary"
            @click="$emit('save')"
            style="margin-top: 70px; width: 100px"
            >保存</Button
          >
        </div>
      </div>
    </el-descriptions-item>
  </el-descriptions>
</template>

<script>
import { saveCarnivalConfigReq } from '@/api/carnivalApi.js'
export default {
  props: {
    value: {
      type: Object,
      default: {},
    },
    docId: {
      type: Number,
      default: '',
    },
    isEditing: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      ticketList: [
        { resourceId: 0, name: '无' },
        { resourceId: 1, name: '抽奖券1' },
        { resourceId: 2, name: '抽奖券2' },
        { resourceId: 3, name: '抽奖券3' },
      ],
    }
  },
  methods: {
    async saveConfig() {
      const res = await saveCarnivalConfigReq(this, this.value)
      if (res.code === 0) {
        this.$Message.success('保存成功')
        this.$emit('refresh')
      } else {
        this.$Message.error(res.msg || res.message)
      }
    },
    getLotteryFeeLabel(index) {
      const labels = ['普通抽奖费:', '高净值抽奖费:', '低价值抽奖费:']
      return labels[index] || `抽奖费${index + 1}:`
    },
  },
  mounted() {},
  computed: {
    formData: {
      get() {
        let _this = this
        return new Proxy(this.value, {
          set(obj, name, val) {
            _this.$emit('input', {
              ...obj,
              [name]: val,
            })
            return true
          },
        })
      },
    },
  },
}
</script>

<style scoped lang="scss">
.btn-group {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
</style>
